// extracted by mini-css-extract-plugin
module.exports = {"StrollerDetailRating":"xy_a bhv_a bhv_x","StrollerDetailRating__muted":"xy_b bhv_fi"};